"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("../index");
exports.PricingGroupAPI = {
    getPricingGroups: function (companyId) { return index_1.axios.get("/api/v1/company/" + companyId + "/pricingGroups").then(function (response) {
        var pricingGroups = response.data.data;
        return pricingGroups;
    }); },
    getPricingGroupById: function (companyId, pricingGroupId) { return index_1.axios.get("/api/v1/company/" + companyId + "/pricingGroup/" + pricingGroupId).then(function (response) {
        var pricingGroup = response.data;
        return pricingGroup;
    }); },
    // Can re-use the get payload for creating and updating
    createPricingGroup: function (companyId, createProduct) { return index_1.axios.post("/api/v1/company/" + companyId + "/pricingGroups", createProduct).then(function (response) {
        var pricingGroup = response.data;
        return pricingGroup;
    }); },
    updatePricingGroup: function (companyId, pricingGroupId, updateObject) { return index_1.axios.put("/api/v1/company/" + companyId + "/pricingGroups/" + pricingGroupId, updateObject).then(function (response) {
        var pricingGroup = response.data;
        return pricingGroup;
    }); },
    deletePricingGroup: function (companyId, pricingGroupId) { return index_1.axios.delete("/api/v1/company/" + companyId + "/pricingGroups/" + pricingGroupId).then(function (response) {
        var pricingGroup = response.data;
        return pricingGroup;
    }); },
};
//# sourceMappingURL=PricingGroupAPI.js.map